import React, {
    useState,
    useEffect,
    useCallback,
    useContext,
    useMemo,
} from "react";
import _, { get } from "lodash";
import PropTypes from "prop-types"
import { ViewModelForm, withViewModelService,ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

import { withRouter } from "react-router-dom";
import { FormattedDate, useTranslator } from "@jutro/locale";
import { MetadataContent } from '@jutro/legacy/uiconfig';
// import { DataTable, DisplayColumn } from "@jutro/datatable";
import { ServiceRequestService } from "gw-capability-servicerequest";
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader, ModalNextContext } from "@jutro/components";
import { LoaderExt } from 'gw-components-platform-react';
import moment from "moment";
import metadata from "./PayrollInvoiceTable.metadata.json5";
import messages from "./PayrollInvoiceTable.messages";
import styles from "./PayrollInvoiceTable.module.scss";
import PayrollService from "../../../../capabilities/cpmi-capability-payroll/services/PayrollService";

import { Link } from '@jutro/router';

function PayrollInvoiceTable(props) {
    
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const [state,setStateName]=useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [viewStartPage, setviewStartPage] = useState(true);
    const [descriptionBoldClass,setDescriptionBoldClass]=useState();
    const ModalNext = useContext(ModalNextContext);

    const { history } = props;
    const reviewData=props.data;

    const getStyle = useCallback((item) => {
        var style = {}

        if (item.isBold) {
            style.fontWeight= "bold"; 
            style.color='black'
        }
        if (item.hasBorder) {
            style.border="1px 0px"
        }
        return style
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getLocationCodeValue = useCallback((item)=>{
        return item.locationCode;
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getLocationNameValue = useCallback((item)=>{
        return item.locationName;
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getGowrningLawValue = useCallback((item)=>{
        return item.gowerningLaw;
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getClassCodeValue = useCallback((item)=>{
        return item.classCode;
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getClassCodeDescValue = useCallback((item)=>{
        const style = getStyle(item)
        return <span style={style}>{item.description}</span>
    })
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getBasicValue = useCallback((item)=>{
        return <span style={{textAlign:"right"}}>{item.basis && String(item?.basis).split(',').join('')|| ''}</span>
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getRateValue = useCallback((item)=>{
        return <span style={{textAlign:"right"}}>{item?.actualAdjRate && Number(item?.actualAdjRate).toFixed(4) || ''}</span>
    })

    const getFormatAmt = (value) => {
        value=value.toFixed(2)
        var val = Math.round(Number(value) * 100) / 100;
        var parts = val.toFixed(2).split(".");
        var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
        return num
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getAmountValue = useCallback((item)=>{
        if((item.description === 'Audit Premium Sub Total' || item.description === 'Audit Premium Total')){
            return <span style={{textAlign:"right"}}>{`$${ getFormatAmt(amount)}`}</span>
        }
        let amountpremium = 0;
        if(item?.actualAmount?.amount !==undefined && item?.actualAmount?.amount){
            amountpremium = getFormatAmt(item?.actualAmount?.amount);
        }
        if(item?.totalAmount?.amount !==undefined && item?.totalAmount?.amount){
            amountpremium = getFormatAmt(item?.totalAmount?.amount);
        }

        var style = getStyle(item)
        style.textAlign="right"
        return <span style={style}>{amountpremium !==0 &&`$${  amountpremium}` || ''}</span>
    
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getNetRateValue = useCallback((item)=>{
        return item.netRate;
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getNetPremiumValue = useCallback((item)=>{
        return (item.description === 'Audit Premium Sub Total' || item.description === 'Audit Premium Total')?<span style={{textAlign:"right"}}>{`$${  item.netPremium.amount}`}</span>:'';
    }) 

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getOtherPremiumClassCode = useCallback((item)=>{
        return item?.classCode?item?.classCode:"";
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getOtherPremiumClassCodeDesc = useCallback((item)=>{
        var style = getStyle(item)
        return item?.description !=="Total Taxes/Surcharges" && item?.description?<span style={style}>{item?.description}</span>:""
    })
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getOtherPremiumBasic = useCallback((item)=>{
        return item?.basis?<span style={{textAlign:"right"}}>{item.basis}</span>:<span style={{textAlign:"right"}} />;
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getOtherPremiumNetRate = useCallback((item)=>{
        return <span style={{textAlign:"right"}}>{item?.actualAdjRate && Number(item?.actualAdjRate).toFixed(4) || ''}</span>;
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getOtherPremiumAmount = useCallback((item)=>{
        if(item?.actualAmount?.amount === 0){
            return <span style={{textAlign:"right"}} />
        }
        var style = getStyle(item)
        style.textAlign="right"
        const amount = item?.actualAmount ? item?.actualAmount?.amount : item.totalAmount?.amount
        return <span style={style}>{`$${getFormatAmt(amount)}`}</span>
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getotherPremiumsLocationCode = useCallback((item)=>{
        return  item?.locationCode || (item?.description !=="Total Taxes/Surcharges" && item?.description?.includes('Total Premium') !== true) && "0";
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getotherPremiumsLocationName = useCallback((item)=>{
        return item?.locationName || (item?.description !=="Total Taxes/Surcharges" && item?.description?.includes('Total Premium') !== true) && "0";
    })

    if(props?.data?.otherPremiums){
        props?.data?.otherPremiums.map((item,index)=>{
            if(item?.description==="Total Taxes/Surcharges"){
                props?.data?.otherPremiums.splice(index,1);
            }
        })
    }
    
    const overrides = {
        payrollStandardPremiumTable: {
            data:props?.data?.standardPremiums,
        },
        payrollOtherPremiumTable:{
            data:props?.data?.otherPremiums,  
        },
        stateTitle:{
            content:<span className="jurisdictionClass">{props?.data?.jurisdictionDisplay}</span>
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        
        resolveCallbackMap: { 
            getLocationCode:getLocationCodeValue,
            getLocationName:getLocationNameValue,
            getGowrningLaw:getGowrningLawValue,
            getClassCode:getClassCodeValue,
            getClassCodeDesc:getClassCodeDescValue,
            getBasic:getBasicValue,
            getRate:getRateValue,
            getAmount:getAmountValue,
            getNetRate:getNetRateValue,
            getNetPremium:getNetPremiumValue,
            getOtherPremiumAmount:getOtherPremiumAmount,
            // getOtherPremiumRate:getOtherPremiumRate,
            getOtherPremiumBasic:getOtherPremiumBasic,
            getOtherPremiumClassCodeDesc:getOtherPremiumClassCodeDesc,
            getOtherPremiumClassCode:getOtherPremiumClassCode,
            getOtherPremiumNetRate:getOtherPremiumNetRate,
            getotherPremiumsLocationCode:getotherPremiumsLocationCode,
            getotherPremiumsLocationName:getotherPremiumsLocationName,  

        },
        resolveComponentMap:{
            
        }
    };

    return (

        <>
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        </>
    );
}
PayrollInvoiceTable.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }),
    }).isRequired,
};

export default withRouter(withViewModelService(PayrollInvoiceTable));
